import { IconBookmark, IconDownload, IconInfo, IconKey, IconPhone, IconPlug, IconPower, IconShare, IconThumbUp, IconUser } from '@assets/images/icon';
import { IconCard, IconTopology } from '@assets/images/main';
import { accessAutoMain, accessLite1, accessProSchemeThumb } from '@assets/images/main/access/product';

export default {
  specTitle: {},

  specData: [
    {
      data: [{ title: 'Công nghệ' }, { text1: 'Ra vào cửa tự động' }, { text2: 'Ra vào nhận diện khuôn mặt' }],
    },
    {
      data: [
        { text: 'Ra vào bằng thiết bị di động' },
        { text: 'Thiết bị giúp ra vào thuận tiện mà không cần mở ứng dụng' },
        { text: 'Thiết bị hỗ trợ nhiều phương thức ra vào như nhận diện khuôn mặt, thẻ NFC v.v.' },
      ],
    },
    {
      data: [{ text: 'Nguồn điện' }, { text: 'DC 12V, 24V' }, { text: 'DC 12V, 3A' }],
    },
  ],

  a: [
    { text: 'Công nghệ', icon: IconInfo },
    { text: 'Ra vào bằng thiết bị di động', icon: IconPhone },
    { text: 'Nguồn điện', icon: IconCard },
    { text: 'Ra vào bằng nhận diện khuôn mặt', icon: IconUser },
    { text: 'Kích thước', icon: IconKey },
    { text: 'Lưu trữ lịch sử ra vào', icon: IconDownload },
    { text: 'Nguồn cấp đầu vào', icon: IconPlug },
    { text: 'Kết nối máy chủ', icon: IconTopology },
    { text: 'Ứng dụng chính', icon: IconBookmark },
    { text: 'Môi trường khuyến nghị', icon: IconThumbUp },
    { text: 'Kết nối bên ngoài', icon: IconShare },
  ],

  b: [
    { text: 'Bluetooth 5, Microwave' },
    { text: 'Hỗ trợ' },
    { text: 'Không hỗ trợ' },
    { text: 'Không hỗ trợ' },
    { text: 'Không hỗ trợ' },
    { text: 'Lưu lịch sử vào' },
    { text: 'DC 12V, 24V (không phân cực)' },
    { text: 'Wifi' },
    { text: 'Khu căn hộ, ký túc xá, bệnh viện, v.v.(các không gian tự động hóa)' },
    { text: 'Theo dõi vị trí phương tiện xe cộ, tài sản' },
    { text: 'Không hỗ trợ' },
  ],

  c: [
    { text: 'Bluetooth 5, NFC' },
    { text: 'Hỗ trợ' },
    { text: 'Hỗ trợ' },
    { text: 'Không hỗ trợ' },
    { text: 'Hỗ trợ' },
    { text: 'Lưu toàn bộ lịch sử ra/vào' },
    { text: 'PoE' },
    { text: 'PoE' },
    { text: 'Văn phòng thông minh, studio, khu vực chia sẻ, v.v.' },
    { text: 'Theo dõi vị trí phương tiện, tài sản' },
    { text: 'Hỗ trợ API' },
  ],

  d: [
    { text: 'Bluetooth 5, NFC, AI' },
    { text: 'Hỗ trợ' },
    { text: 'Hỗ trợ' },
    { text: 'Hỗ trợ' },
    { text: 'Hỗ trợ' },
    { text: 'Lưu toàn bộ lịch sử ra/vào' },
    { text: 'Adapter 12V / 3A' },
    { text: 'PoE, Wi-Fi' },
    { text: 'Tòa nhà cao cấp, sảnh chung, phòng kiểm soát ra vào' },
    { text: 'Khu vực bãi, cảng, trung tâm logistics, công trường xây dựng, v.v.' },
    { text: 'Hỗ trợ API' },
  ],

  spec: [
    {},
    {
      image: accessAutoMain,
      link: '/vi/access/auto',
      title: 'Access Auto',
    },
    {
      image: accessLite1,
      link: '/vi/access/lite',
      title: 'Access Lite',
    },
    {
      image: accessProSchemeThumb,
      link: '/vi/access/pro',
      title: 'Access Pro',
    },
  ],
};
